(function () {
    function openThirdLevelMenus() {
      if (!window.matchMedia('(max-width: 768px)').matches) return;
      document.querySelectorAll('.child-nav .js-mega-nav details').forEach(function (d) {
        d.open = true;
      });
    }
    var root = document.documentElement;
    var mobileMenuQuery = window.matchMedia('(max-width: 768px)');
    var menuTopOffsetThreshold = 70;
    var menuSelectors = [
      '#MenuDrawer',
      '#menu-drawer',
      'menu-drawer',
      'nav-drawer',
      '.menu-drawer',
      '.mobile-menu',
      '.mobile-nav',
      '.main-menu',
      '[data-menu-drawer]',
      '[data-mobile-menu]'
    ].join(',');
    function isVisibleMenuElement(el) {
      if (!el || !el.getBoundingClientRect) return false;
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
      var rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0;
    }
    function looksLikeOpenMobileMenu(el) {
      if (!isVisibleMenuElement(el)) return false;
      if (
        el.hasAttribute('open') ||
        el.getAttribute('aria-hidden') === 'false' ||
        el.classList.contains('is-open') ||
        el.classList.contains('is-visible') ||
        el.classList.contains('active') ||
        el.classList.contains('drawer--visible') ||
        el.classList.contains('menu-open')
      ) {
        return true;
      }
      var rect = el.getBoundingClientRect();
      return rect.height > 260 && rect.top < 220 && rect.left < window.innerWidth && rect.right > 0;
    }
    function hasOpenMenuButtonState() {
      return !!document.querySelector([
        'button[aria-expanded="true"][aria-controls*="menu" i]',
        'button[aria-expanded="true"][aria-controls*="drawer" i]',
        'summary[aria-expanded="true"][aria-controls*="menu" i]',
        '[data-menu-toggle][aria-expanded="true"]',
        '[data-mobile-menu-toggle][aria-expanded="true"]'
      ].join(','));
    }
    function isMobileMenuOpen() {
      if (!mobileMenuQuery.matches) return false;
      var authoritativeToggle = document.querySelector('.main-menu__toggle[aria-controls="main-menu-content"]');
      if (authoritativeToggle) {
        return authoritativeToggle.getAttribute('aria-expanded') === 'true';
      }
      var menus = document.querySelectorAll(menuSelectors);
      for (var i = 0; i < menus.length; i += 1) {
        if (looksLikeOpenMobileMenu(menus[i])) return true;
      }
      return hasOpenMenuButtonState();
    }
    function blurHeaderSearchIfOpen() {
      if (Date.now() < Number(window.QLSMobileSearchHandoffUntil || 0)) return;
      if (!document.activeElement || !document.activeElement.closest) return;
      var activeSearch = document.activeElement.closest('form[action*="/search"], predictive-search, .header__search, .header-search, .search-bar, .site-search');
      if (activeSearch) {
        document.activeElement.blur();
      }
    }
    function syncMobileMenuOpenClass() {
      var open = isMobileMenuOpen();
      var nearTop = (window.scrollY || window.pageYOffset || 0) <= menuTopOffsetThreshold;
      var searchWasOpen = root.classList.contains('qls-mobile-search-opened');
      var enhancedDrawer = !!document.querySelector('store-header.qls-mobile-header--enhanced');
      root.classList.toggle('qls-mobile-menu-open', open);
      root.classList.toggle('qls-mobile-menu-top-offset', open && !enhancedDrawer && (nearTop || searchWasOpen));
      if (open) {
        blurHeaderSearchIfOpen();
      }
    }
    function queueMobileMenuOpenSync() {
      setTimeout(syncMobileMenuOpenClass, 30);
      setTimeout(syncMobileMenuOpenClass, 180);
      setTimeout(syncMobileMenuOpenClass, 500);
    }
    document.addEventListener('DOMContentLoaded', openThirdLevelMenus);
    document.addEventListener('click', function (e) {
      var menuTrigger =
        e.target.closest('button[aria-controls]') ||
        e.target.closest('.header__icon--menu') ||
        e.target.closest('[data-drawer-open]') ||
        e.target.closest('summary');
      if (!menuTrigger) return;
      setTimeout(openThirdLevelMenus, 50);
      setTimeout(openThirdLevelMenus, 200);
      queueMobileMenuOpenSync();
    });
    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') {
        setTimeout(syncMobileMenuOpenClass, 30);
      }
    }, true);
    window.addEventListener('resize', function () {
      setTimeout(openThirdLevelMenus, 50);
      setTimeout(syncMobileMenuOpenClass, 80);
    });
    window.addEventListener('scroll', function () {
      if (!root.classList.contains('qls-mobile-menu-open')) return;
      syncMobileMenuOpenClass();
    }, { passive: true });
    setInterval(syncMobileMenuOpenClass, 750);
    syncMobileMenuOpenClass();
  })();
  (function () {
    var observerStarted = false;
    var mobileQuery = window.matchMedia('(max-width: 768px)');
    function shouldRunCartWalletFix() {
      return mobileQuery.matches;
    }
    function forceHorizontal() {
      if (!shouldRunCartWalletFix()) return;
      var host = document.querySelector('#dynamic-checkout-cart.dynamic-checkout__content');
      if (!host) return;
      var accel = host.querySelector('shopify-accelerated-checkout-cart');
      if (!accel) return;
      host.classList.add('additional-checkout-buttons--horizontal');
      host.classList.remove('additional-checkout-buttons--vertical');
      var parent = host.closest('.dynamic-cart-btns, .additional-checkout-buttons') || host.parentElement;
      if (parent) {
        parent.classList.add('additional-checkout-buttons--horizontal');
        parent.classList.remove('additional-checkout-buttons--vertical');
      }
      accel.style.setProperty('--shopify-accelerated-checkout-inline-alignment', 'stretch');
      accel.style.setProperty('--shopify-accelerated-checkout-row-gap', '10px');
      accel.style.setProperty('--shopify-accelerated-checkout-button-border-radius', '6px');
      accel.style.setProperty('width', '100%');
      accel.style.setProperty('max-width', '100%');
      accel.style.display = 'block';
    }
    function runForceHorizontalBurst() {
      if (!shouldRunCartWalletFix()) return;
      forceHorizontal();
      setTimeout(forceHorizontal, 50);
      setTimeout(forceHorizontal, 150);
      setTimeout(forceHorizontal, 250);
      setTimeout(forceHorizontal, 500);
      setTimeout(forceHorizontal, 800);
      setTimeout(forceHorizontal, 1200);
      setTimeout(forceHorizontal, 1500);
      setTimeout(forceHorizontal, 2200);
    }
    function startCartWalletObserver() {
      if (observerStarted) return;
      if (!shouldRunCartWalletFix()) return;
      observerStarted = true;
      var root = document.body || document.documentElement;
      if (!root || !window.MutationObserver) return;
      var obs = new MutationObserver(function () {
        if (!shouldRunCartWalletFix()) return;
        forceHorizontal();
      });
      obs.observe(root, {
        childList: true,
        subtree: true
      });
    }
    function bootCartWalletFix() {
      if (!shouldRunCartWalletFix()) return;
      startCartWalletObserver();
      runForceHorizontalBurst();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootCartWalletFix);
    } else {
      bootCartWalletFix();
    }
    window.addEventListener('load', bootCartWalletFix);
    document.addEventListener('click', function (event) {
      if (!shouldRunCartWalletFix()) return;
      if (!event.target || !event.target.closest) return;
      var trigger = event.target.closest(
        '.header__icon--cart, a[href="/cart"], button[name="add"], #ccMobileStickyAtcBtn'
      );
      if (!trigger) return;
      runForceHorizontalBurst();
    }, true);
    document.addEventListener('submit', function (event) {
      if (!shouldRunCartWalletFix()) return;
      if (!event.target || !event.target.matches) return;
      var isCartAddForm =
        event.target.matches('form[action*="/cart/add"]') ||
        event.target.classList.contains('js-product-form-main');
      if (!isCartAddForm) return;
      runForceHorizontalBurst();
    }, true);
    [
      'cart:updated',
      'cart:refresh',
      'cart-drawer:open',
      'cart-drawer:opened',
      'cart:open',
      'cart:opened',
      'theme:cart:change',
      'ajaxProduct:added',
      'product:added',
      'shopify:section:load'
    ].forEach(function (eventName) {
      document.addEventListener(eventName, runForceHorizontalBurst);
    });
    window.addEventListener('resize', function () {
      if (shouldRunCartWalletFix()) {
        bootCartWalletFix();
        runForceHorizontalBurst();
      }
    }, { passive: true });
    window.addEventListener('orientationchange', function () {
      if (shouldRunCartWalletFix()) {
        bootCartWalletFix();
        runForceHorizontalBurst();
      }
    }, { passive: true });
  })();
  (function () {
    var root = document.documentElement;
    var mobileQuery = window.matchMedia('(max-width: 768px)');
    var scrollThreshold = 56;
    var openedByIcon = false;
    var openedAtScrollY = 0;
    var lastSearchOpenScrollY = 0;
    var searchScrollCloseThreshold = 64;
    var searchScrollCloseBlockedUntil = 0;
    var ticking = false;
    function getHeader() {
      return document.querySelector('store-header.header, store-header, .header');
    }
    function getSearchInput(header) {
      if (!header) return null;
      return header.querySelector('.header__search .js-search-input, .header__search input[type="search"]');
    }
    function getScrollY() {
      return window.scrollY || window.pageYOffset || 0;
    }
    var focusedSearchScrollY = 0;
    function stabilizeFocusedSearch(input) {
      if (!mobileQuery.matches || !input || document.activeElement !== input) return;
      /* Do not force window.scrollTo while iOS is opening its keyboard. That
         fights Safari's viewport adjustment and causes the visible jitter. */
      window.QLSMobileInputFocusGuardUntil = Date.now() + 3000;
      root.classList.add('qls-mobile-search-focus', 'qls-mobile-search-opened');
      root.classList.remove('qls-mobile-search-compact');
      syncThemeHeaderOpenState();
    }

    function focusSearchInput(input) {
      if (!input) return false;
      window.QLSMobileInputFocusGuardUntil = Date.now() + 3000;
      try {
        input.focus({ preventScroll: true });
      } catch (error) {
        input.focus();
      }
      try {
        var end = String(input.value || '').length;
        input.setSelectionRange(end, end);
      } catch (error) {}
      return document.activeElement === input;
    }
    function speechSearchSupported() {
      var userAgent = window.navigator.userAgent.toLowerCase();
      return (
        'webkitSpeechRecognition' in window &&
        userAgent.indexOf('chrome') > -1 &&
        !!window.chrome &&
        userAgent.indexOf('edg/') === -1
      );
    }
    function updateSpeechSupport() {
      if (speechSearchSupported()) {
        root.classList.remove('qls-speech-unsupported');
      } else {
        root.classList.add('qls-speech-unsupported');
      }
    }
    function enhanceSpeechButtons() {
      var buttons = document.querySelectorAll('.search__speech');
      buttons.forEach(function (button) {
        if (button.querySelector('.qls-voice-wave')) return;
        var wave = document.createElement('span');
        wave.className = 'qls-voice-wave';
        wave.setAttribute('aria-hidden', 'true');
        for (var i = 0; i < 4; i += 1) {
          var bar = document.createElement('span');
          wave.appendChild(bar);
        }
        button.appendChild(wave);
      });
    }
    function isSearchFocused() {
      var active = document.activeElement;
      return !!(active && active.closest && active.closest('.header__search'));
    }
    function syncThemeHeaderOpenState() {
      var header = getHeader();
      if (!header) return;
      header.classList.remove('search-is-collapsed');
      header.classList.add('search-is-visible');
    }
    function syncThemeHeaderCollapsedState() {
      var header = getHeader();
      if (!header) return;
      header.classList.remove('search-is-visible');
      if (header.dataset && header.dataset.isSearchMinimised) {
        header.classList.add('search-is-collapsed');
      }
    }
    function ensureSearchToggle() {
      var header = getHeader();
      if (!header) return null;
      var icons = header.querySelector('.header__icons');
      if (!icons) return null;
      var existing = icons.querySelector('.qls-mobile-search-toggle');
      if (existing) return existing;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'qls-mobile-search-toggle';
      button.setAttribute('aria-label', 'Open search');
      button.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<path d="M10.5 18a7.5 7.5 0 1 1 5.3-12.8A7.5 7.5 0 0 1 10.5 18Zm0-2a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z" fill="currentColor"></path>' +
          '<path d="M15.6 15.6 21 21" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>' +
        '</svg>';
      icons.insertBefore(button, icons.firstChild);
      return button;
    }
    function openSearchFromIcon() {
      var header = getHeader();
      var input = getSearchInput(header);
      if (typeof window.QLSCloseHeaderDeliveryMenus === 'function') {
        window.QLSCloseHeaderDeliveryMenus();
      }
      openedByIcon = true;
      openedAtScrollY = getScrollY();
      focusedSearchScrollY = openedAtScrollY;
      lastSearchOpenScrollY = openedAtScrollY;
      searchScrollCloseBlockedUntil = Date.now() + 3000;
      root.classList.remove('qls-mobile-search-compact');
      root.classList.add('qls-mobile-search-opened', 'qls-mobile-search-focus');
      syncThemeHeaderOpenState();

      /* Must happen inside the original tap call stack for iOS to open the
         keyboard. Retried focus only acts as a fallback. */
      focusSearchInput(input);
      window.requestAnimationFrame(function () {
        if (document.activeElement !== input) focusSearchInput(input);
      });
      window.setTimeout(function () {
        if (document.activeElement !== input) focusSearchInput(input);
      }, 80);
      return input;
    }

    window.QLSOpenMobileSearch = function () {
      return openSearchFromIcon();
    };
    function expandSearchAtTop() {
      openedByIcon = false;
      openedAtScrollY = 0;
      lastSearchOpenScrollY = 0;
      searchScrollCloseBlockedUntil = 0;
      root.classList.remove('qls-mobile-search-compact');
      root.classList.remove('qls-mobile-search-opened');
      syncThemeHeaderOpenState();
    }
    function collapseSearch(forceBlur) {
      var header = getHeader();
      var input = getSearchInput(header);
      if (forceBlur && input && document.activeElement === input) {
        input.blur();
      }
      if (!forceBlur && isSearchFocused()) return;
      openedByIcon = false;
      lastSearchOpenScrollY = 0;
      searchScrollCloseBlockedUntil = 0;
      root.classList.remove('qls-mobile-search-opened');
      root.classList.add('qls-mobile-search-compact');
      syncThemeHeaderCollapsedState();
    }
    function closeSearchFromOutside() {
      if (!mobileQuery.matches) return;
      if (getScrollY() <= scrollThreshold) return;
      openedByIcon = false;
      openedAtScrollY = 0;
      collapseSearch(true);
    }
    function targetIsInsideSearchExperience(target) {
      if (!target || !target.closest) return false;
      return !!target.closest([
        '.header__search',
        '.qls-mobile-search-toggle',
        '.header__icons .js-show-search',
        '.header__icon--search-left',
        'predictive-search',
        '.predictive-search',
        '.search__reset',
        '.search__speech',
        'custom-select#product_types'
      ].join(','));
    }
    function handOffOpenSearch(target) {
      if (!root.classList.contains('qls-mobile-search-opened') || !target || !target.closest) return false;

      var cartTrigger = target.closest('#cart-icon');
      var deliverySummary = target.closest('[data-qls-delivery-menu] > summary');
      if (!cartTrigger && !deliverySummary) return false;

      openedByIcon = false;
      openedAtScrollY = 0;
      lastSearchOpenScrollY = 0;
      searchScrollCloseBlockedUntil = 0;
      collapseSearch(true);

      if (cartTrigger) {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
          detail: { opener: cartTrigger }
        }));
      } else {
        var deliveryDetails = deliverySummary.closest('[data-qls-delivery-menu]');
        if (deliveryDetails) deliveryDetails.open = true;
      }
      return true;
    }
    function updateSearchState() {
      ticking = false;
      ensureSearchToggle();
      updateSpeechSupport();
      enhanceSpeechButtons();
      if (!mobileQuery.matches) {
        openedByIcon = false;
        openedAtScrollY = 0;
        root.classList.remove('qls-mobile-search-compact');
        root.classList.remove('qls-mobile-search-opened');
        syncThemeHeaderOpenState();
        return;
      }
      var y = getScrollY();
      /* Check focus before the top-of-page branch. iOS can temporarily alter
         scrollY while opening the keyboard; treating that as a real trip to
         the top caused the header to collapse/expand and visibly jitter. */
      if (isSearchFocused()) {
        openedByIcon = true;
        root.classList.remove('qls-mobile-search-compact');
        root.classList.add('qls-mobile-search-opened');
        syncThemeHeaderOpenState();
        return;
      }
      if (y <= scrollThreshold) {
        expandSearchAtTop();
        return;
      }
      if (openedByIcon) {
        root.classList.remove('qls-mobile-search-compact');
        root.classList.add('qls-mobile-search-opened');
        syncThemeHeaderOpenState();
        return;
      }
      collapseSearch(false);
    }
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateSearchState);
    }
    function bindSearchInputEvents() {
      var header = getHeader();
      var input = getSearchInput(header);
      if (!input || input.dataset.qlsSearchBound === 'true') return;
      input.dataset.qlsSearchBound = 'true';
      input.addEventListener('focus', function () {
        if (!mobileQuery.matches) return;
        openedByIcon = true;
        openedAtScrollY = getScrollY();
        focusedSearchScrollY = openedAtScrollY;
        lastSearchOpenScrollY = openedAtScrollY;
        searchScrollCloseBlockedUntil = Date.now() + 3200;
        root.classList.add('qls-mobile-search-focus');
        root.classList.remove('qls-mobile-search-compact');
        root.classList.add('qls-mobile-search-opened');
        syncThemeHeaderOpenState();
        stabilizeFocusedSearch(input);
      });
      input.addEventListener('input', function () {
        if (!mobileQuery.matches) return;
        openedByIcon = true;
        openedAtScrollY = getScrollY();
        lastSearchOpenScrollY = getScrollY();
        searchScrollCloseBlockedUntil = Date.now() + 900;
        root.classList.remove('qls-mobile-search-compact');
        root.classList.add('qls-mobile-search-opened');
        syncThemeHeaderOpenState();
      });
      input.addEventListener('blur', function () {
        if (!mobileQuery.matches) return;
        setTimeout(function () {
          if (document.activeElement !== input) root.classList.remove('qls-mobile-search-focus');
          updateSearchState();
        }, 350);
      });
    }
    document.addEventListener('click', function (event) {
      if (!mobileQuery.matches) return;
      if (!event.target || !event.target.closest) return;
      if (handOffOpenSearch(event.target)) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        return;
      }
      var trigger = event.target.closest(
        '.qls-mobile-search-toggle, .header__icons .js-show-search, .header__icon--search-left'
      );
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        }
        if (root.classList.contains('qls-mobile-search-opened')) {
          openedByIcon = false;
          openedAtScrollY = 0;
          lastSearchOpenScrollY = 0;
          searchScrollCloseBlockedUntil = 0;
          collapseSearch(true);
          return;
        }
        openSearchFromIcon();
        return;
      }
      if (
        root.classList.contains('qls-mobile-search-opened') &&
        getScrollY() > scrollThreshold &&
        !targetIsInsideSearchExperience(event.target)
      ) {
        closeSearchFromOutside();
      }
    }, true);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        updateSpeechSupport();
        enhanceSpeechButtons();
        ensureSearchToggle();
        bindSearchInputEvents();
        updateSearchState();
      });
    } else {
      updateSpeechSupport();
      enhanceSpeechButtons();
      ensureSearchToggle();
      bindSearchInputEvents();
      updateSearchState();
    }
    window.addEventListener('scroll', function () {
      if (
        mobileQuery.matches &&
        openedByIcon &&
        root.classList.contains('qls-mobile-search-opened')
      ) {
        if (isSearchFocused() || Date.now() < searchScrollCloseBlockedUntil) {
          requestUpdate();
          return;
        }
        if (Math.abs(getScrollY() - lastSearchOpenScrollY) > searchScrollCloseThreshold) {
          openedByIcon = false;
          openedAtScrollY = 0;
          lastSearchOpenScrollY = 0;
          searchScrollCloseBlockedUntil = 0;
          collapseSearch(true);
          return;
        }
      }
      requestUpdate();
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (isSearchFocused()) return;
      requestUpdate();
    }, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        var header = getHeader();
        var input = getSearchInput(header);
        if (input && document.activeElement === input) {
          searchScrollCloseBlockedUntil = Date.now() + 1800;
          stabilizeFocusedSearch(input);
          return;
        }
        requestUpdate();
      }, { passive: true });
    }
    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        updateSpeechSupport();
        enhanceSpeechButtons();
        bindSearchInputEvents();
        updateSearchState();
      }, 350);
    }, { passive: true });
    setTimeout(function () {
      updateSpeechSupport();
      enhanceSpeechButtons();
      bindSearchInputEvents();
      updateSearchState();
    }, 500);
  })();


/* QLS v110 — keep header dimension variables in sync with compact sticky state */
(function () {
  function initCompactStickyHeaderDimensions() {
    var header = document.querySelector(
      'store-header.qls-header--shrink-logo-on-scroll[data-is-sticky="true"]'
    );

    if (!header || !window.MutationObserver) return;

    var lastIsOut = header.classList.contains('is-out');
    var updateTimer;

    function updateDimensions() {
      if (typeof window.setHeaderHeight === 'function') {
        window.setHeaderHeight();
      }

      if (typeof header.setHeaderEnd === 'function') {
        header.setHeaderEnd();
      }
    }

    var observer = new MutationObserver(function (mutations) {
      var classChanged = mutations.some(function (mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'class';
      });

      if (!classChanged) return;

      var isOut = header.classList.contains('is-out');
      if (isOut === lastIsOut) return;
      lastIsOut = isOut;

      clearTimeout(updateTimer);
      requestAnimationFrame(updateDimensions);
      updateTimer = setTimeout(updateDimensions, 340);
    });

    observer.observe(header, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompactStickyHeaderDimensions);
  } else {
    initCompactStickyHeaderDimensions();
  }
})();
